import React from 'react';
import { View, Text, Image, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';
function ActionButton({ label, onPress }) {
  return (
    <TouchableOpacity style={styles.actionButton} onPress={onPress}>
      <Text style={styles.actionButtonText}>{label}</Text>
    </TouchableOpacity>
  );
}

const overlayText = '#f5f5f5';

/**
 * Media Manager tile for a library `roomEqSubmission` row — distinct from {@link VenueCardFile}
 * (per-submission Room EQ, optional EQ/RF preview image, title “{Venue} room info”).
 */
export function RoomEqSubmissionCardFile({
  displayName,
  previewImageUrl,
  fallbackVenueImageUrl,
  onViewVenue,
  onViewSubmission,
}) {
  const img = previewImageUrl || fallbackVenueImageUrl || null;

  return (
    <View style={styles.container}>
      <View style={styles.cardOuter}>
        <View style={styles.imageContainer}>
          {img ? (
            <Image source={{ uri: img }} style={styles.image} resizeMode="cover" />
          ) : (
            <LinearGradient
              colors={['#1e3a5f', '#0f766e']}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 1 }}
              style={styles.placeholderGradient}
            >
              <Ionicons name="pulse" size={36} color="rgba(255,255,255,0.9)" />
              <Text style={[styles.placeholderHint, { color: overlayText }]} numberOfLines={2}>
                Room EQ
              </Text>
            </LinearGradient>
          )}

          <LinearGradient
            colors={['rgba(0,0,0,0)', 'rgba(0,0,0,0.65)']}
            style={styles.gradientOverlay}
          >
            <View style={styles.contentContainer}>
              <View style={styles.textContainer}>
                <Text style={[styles.title, { color: overlayText }]} numberOfLines={2}>
                  {displayName || 'Room info'}
                </Text>
                <Text style={[styles.subtitle, { color: overlayText }]} numberOfLines={1}>
                  Submission
                </Text>
              </View>
              <View style={styles.buttonsContainer}>
                <ActionButton label="Venue" onPress={onViewVenue} />
                <ActionButton label="View" onPress={onViewSubmission} />
              </View>
            </View>
          </LinearGradient>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    marginBottom: 15,
    borderRadius: 12,
    overflow: 'hidden',
  },
  cardOuter: {
    height: '100%',
    borderRadius: 12,
    overflow: 'hidden',
    borderWidth: 2,
    borderColor: 'rgba(15, 118, 110, 0.45)',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.12,
    shadowRadius: 4,
    elevation: 3,
  },
  imageContainer: {
    position: 'relative',
    height: '100%',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  placeholderGradient: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: 12,
  },
  placeholderHint: {
    fontSize: 11,
    fontFamily: 'VastagoGrotesk',
    opacity: 0.95,
    textAlign: 'center',
  },
  gradientOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingHorizontal: 8,
    paddingTop: 12,
    paddingBottom: 8,
  },
  contentContainer: {
    flexDirection: 'column',
    gap: 8,
    width: '100%',
  },
  textContainer: {
    minWidth: 0,
  },
  title: {
    fontSize: 11,
    fontFamily: 'VastagoGrotesk',
    fontWeight: '700',
    marginBottom: 2,
  },
  subtitle: {
    fontSize: 8,
    fontFamily: 'VastagoGrotesk',
    opacity: 0.85,
  },
  buttonsContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    gap: 6,
  },
  actionButton: {
    backgroundColor: 'rgba(20, 40, 50, 0.85)',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 6,
    alignItems: 'center',
  },
  actionButtonText: {
    color: '#ffffff',
    fontSize: 10,
    fontFamily: 'VastagoGrotesk',
    fontWeight: '600',
  },
});
